import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector : 'set-font',
    templateUrl : './set-font.component.html'
})
export class SetFontComponent {

    @Input()
    fontType = '';

    @Output()
    change: EventEmitter<string> = new EventEmitter<string>();

    fontChange() {
        this.change.emit(this.fontType);
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/poster/make/set-font/set-font.component.ts